/**
 * As refernce Shopify documentation
 * https://shopify.dev/docs/storefronts/themes/product-merchandising/gift-cards
 *
 */

/**
 * Constants defined by Shopify to add recipient information on a Digital Gift Card
 */
const GIFT_CART_RECIPIENT_FLAG_ATTRIBUTE = '__shopify_send_gift_card_to_recipient';
const GIFT_CART_RECIPIENT_EMAIL_ATTRIBUTE = 'Recipient email';
const GIFT_CART_RECIPIENT_NAME_ATTRIBUTE = 'Recipient name';
const GIFT_CART_MESSAGE_ATTRIBUTE = 'Message';
const GIFT_CART_SEND_ON_ATTRIBUTE = 'Send on';
const GIFT_CART_OFFSET_ATTRIBUTE = '__shopify_offset';

/**
 * Default values for Digital Gift Card recipient fields
 */
const GIFT_CART_RECIPIENT_FLAG_ON = 'on';
const GIFT_CART_OFFSET_DEFAULT = '180';

/**
 * Constants for the Cart Model shared between Storefront and Ajax Cart API
 */
const GIFT_CART_MODEL_PROPERTY_IS_DGC_WITH_RECIPIENT_EMAIL = 'isDigitalGiftCardWithRecipientEmail';
const GIFT_CART_MODEL_PROPERTY_DGC_EMAIL = 'digitalGiftCardRecipientEmail';
const GIFT_CART_MODEL_PROPERTY_DGC_NAME = 'digitalGiftCardRecipientName';
const GIFT_CART_MODEL_PROPERTY_DGC_SEND_ON = 'digitalGiftCardRecipientSendOn';

/**
 * Constants for modal and form
 */
const MODAL_CLOSE_TIMEOUT_MS = 150;
const INPUT_EMPTY_TEXT = '';
const INPUT_EMPTY_DATE = '';
const INPUT_DATE_PATTERN = 'd{4}-d{2}-d{2}';
const TEXTAREA_MAX_LENGTH = 200;
const TEXTAREA_MAX_HEIGHT = 100;
const DATE_MAX_SEND_ON_DAYS = 90;
const INPUT_NAME_MAX_LENGTH = 255;

export {
  GIFT_CART_RECIPIENT_FLAG_ATTRIBUTE,
  GIFT_CART_RECIPIENT_EMAIL_ATTRIBUTE,
  GIFT_CART_RECIPIENT_NAME_ATTRIBUTE,
  GIFT_CART_MESSAGE_ATTRIBUTE,
  GIFT_CART_SEND_ON_ATTRIBUTE,
  GIFT_CART_OFFSET_ATTRIBUTE,
  GIFT_CART_RECIPIENT_FLAG_ON,
  GIFT_CART_OFFSET_DEFAULT,
  GIFT_CART_MODEL_PROPERTY_IS_DGC_WITH_RECIPIENT_EMAIL,
  GIFT_CART_MODEL_PROPERTY_DGC_EMAIL,
  GIFT_CART_MODEL_PROPERTY_DGC_NAME,
  GIFT_CART_MODEL_PROPERTY_DGC_SEND_ON,
  MODAL_CLOSE_TIMEOUT_MS,
  INPUT_EMPTY_TEXT,
  INPUT_EMPTY_DATE,
  INPUT_DATE_PATTERN,
  INPUT_NAME_MAX_LENGTH,
  TEXTAREA_MAX_LENGTH,
  TEXTAREA_MAX_HEIGHT,
  DATE_MAX_SEND_ON_DAYS,
};
